const EXIT_MODAL_I18N_FALLBACK = {
  alertInvalidPhone: 'Please enter a valid phone number.',
  alertSuccess: 'Your message was sent successfully!',
};

function getExitModalI18nStrings() {
  var el = document.getElementById('exit-modal-i18n');
  if (!el) return EXIT_MODAL_I18N_FALLBACK;
  try {
    var parsed = JSON.parse(el.textContent);
    return /** @type {typeof EXIT_MODAL_I18N_FALLBACK} */ ({ ...EXIT_MODAL_I18N_FALLBACK, ...parsed });
  } catch {
    return EXIT_MODAL_I18N_FALLBACK;
  }
}

const initExitModal = (root = document) => {
  const dialog = root.querySelector('[data-exit-modal]');
  if (!dialog || dialog.dataset.exitInit === 'true') return;
  dialog.dataset.exitInit = 'true';
  const STR = getExitModalI18nStrings();

  const open = () => {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const close = () => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  dialog.querySelectorAll('[data-exit-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      close();
    });
  });

  // Máscara de telefone (XX) XXXXX-XXXX
  var phoneInput = dialog.querySelector('input[type="tel"]');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      var v = this.value.replace(/\D/g, '').slice(0, 11);
      if (v.length > 6) {
        this.value = '(' + v.slice(0, 2) + ') ' + v.slice(2, 7) + '-' + v.slice(7);
      } else if (v.length > 2) {
        this.value = '(' + v.slice(0, 2) + ') ' + v.slice(2);
      } else if (v.length > 0) {
        this.value = '(' + v;
      }
    });
  }

  // Submit do formulário → Google Sheets via App Proxy
  var formEl = dialog.querySelector('[data-exit-form]');
  if (formEl) {
    formEl.addEventListener('submit', function (event) {
      event.preventDefault();

      var mensagem = (dialog.querySelector('textarea') || {}).value || '';
      var nome = (dialog.querySelector('input[type="text"]') || {}).value || '';
      var telefone = (dialog.querySelector('input[type="tel"]') || {}).value || '';
      var email = (dialog.querySelector('input[type="email"]') || {}).value || '';

      // Validação extra (telefone mínimo 10 dígitos)
      if (telefone.replace(/\D/g, '').length < 10) {
        alert(STR.alertInvalidPhone);
        return;
      }

      var params = new URLSearchParams(window.location.search);

      var data = {
        nome: nome.trim(),
        email: email.trim(),
        telefone: telefone.trim(),
        mensagem: mensagem.trim(),
        data_nascimento: '',
        estado: '',
        categorias: '',
        origem: 'exit-modal',
        page_url: window.location.href,
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_term: params.get('utm_term') || '',
        utm_content: params.get('utm_content') || ''
      };

      navigator.sendBeacon(
        '/apps/hub-proxy/api/form-submit',
        new Blob([JSON.stringify(data)], { type: 'application/json' })
      );

      close();
      alert(STR.alertSuccess);
    });
  }

  window.openExitModal = open;
  window.closeExitModal = close;
};

document.addEventListener('DOMContentLoaded', () => initExitModal());
document.addEventListener('shopify:section:load', (event) => initExitModal(event.target));
